/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createProductFamilyFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ProductFamily } from '../../../models/index.js';
// @ts-ignore
import { type VariantsRequestBuilder, VariantsRequestBuilderRequestsMetadata } from './variants/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/product-families/{familyKey}
 */
export interface WithFamilyKeyItemRequestBuilder extends BaseRequestBuilder<WithFamilyKeyItemRequestBuilder> {
    /**
     * The variants property
     */
    get variants(): VariantsRequestBuilder;
    /**
     * Removes the family and returns every one of its variants to a standalone product. The products themselves, their prices, stock and images are untouched — only the grouping goes.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Returns one family with its option axes (labelled and ordered from the organization's product options, each value flagged available or not) and every variant in grid order, priced for the caller's tier. The first option is the grid's rows and the second its columns; look each variant up by its optionValues to place it in a cell, and render a cell no variant matches as unavailable. Not found when the organization has not enabled product variants.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ProductFamily>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ProductFamily | undefined>;
    /**
     * Removes the family and returns every one of its variants to a standalone product. The products themselves, their prices, stock and images are untouched — only the grouping goes.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Returns one family with its option axes (labelled and ordered from the organization's product options, each value flagged available or not) and every variant in grid order, priced for the caller's tier. The first option is the grid's rows and the second its columns; look each variant up by its optionValues to place it in a cell, and render a cell no variant matches as unavailable. Not found when the organization has not enabled product variants.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithFamilyKeyItemRequestBuilderUriTemplate = "{+baseurl}/api/product-families/{familyKey}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithFamilyKeyItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithFamilyKeyItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    variants: {
        requestsMetadata: VariantsRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithFamilyKeyItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithFamilyKeyItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: WithFamilyKeyItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createProductFamilyFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
